import { CREATE_PATIENT_CARD, RESET_PATIENT_CREATION } from './actionTypes';
import axios from 'axios';

export function addPatientCard(item) {
  return {
    type: CREATE_PATIENT_CARD,
    item,
  };
}

export function resetPatientCreation() {
  return {
    type: RESET_PATIENT_CREATION,
  };
}
export function sendCreateCard() {
  return async (dispath, getState) => {
    await axios.post(
      'https://react-cvad.firebaseio.com/pacients.json',
      getState().create.patient
    );
    dispath(resetPatientCreation());
  };
}
